(function () {
  'use strict';

  var loading = false;
  var observer = null;

  function announce(message) {
    var statusEl = document.getElementById('yn-journal-status');
    if (statusEl) statusEl.textContent = message;
  }

  function setLoadingState(link, isLoading) {
    if (!link) return;
    var label = link.querySelector('.yn-journal__load-more-label');
    var spinner = link.querySelector('.yn-journal__load-more-spinner');
    link.classList.toggle('is-loading', isLoading);
    link.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    if (spinner) spinner.hidden = !isLoading;
    if (label) label.textContent = isLoading ? 'Loading more stories…' : 'Load more stories';
  }

  function observePagination(container) {
    if (!container || !('IntersectionObserver' in window)) return;
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNextPage();
        });
      },
      { rootMargin: '400px 0px 400px 0px' }
    );
    observer.observe(container);
  }

  function bindClick(link) {
    if (!link) return;
    link.addEventListener('click', function (event) {
      event.preventDefault();
      loadNextPage();
    });
  }

  function loadNextPage() {
    if (loading) return;

    var container = document.getElementById('yn-journal-pagination');
    var link = document.getElementById('yn-journal-load-more');
    if (!container || !link) return;

    var nextUrl = link.getAttribute('data-next-url') || link.getAttribute('href');
    if (!nextUrl) return;

    var sectionId = container.getAttribute('data-section-id');
    var fetchUrl = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);

    loading = true;
    setLoadingState(link, true);

    fetch(fetchUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('yn-journal-grid');
        var newPagination = doc.getElementById('yn-journal-pagination');
        var currentGrid = document.getElementById('yn-journal-grid');
        var addedCount = 0;

        if (newGrid && currentGrid) {
          addedCount = newGrid.children.length;
          while (newGrid.firstChild) {
            currentGrid.appendChild(newGrid.firstChild);
          }
        }

        if (newPagination && newPagination.querySelector('#yn-journal-load-more')) {
          container.replaceWith(newPagination);
          bindClick(newPagination.querySelector('#yn-journal-load-more'));
          observePagination(newPagination);
        } else {
          container.parentNode && container.remove();
          if (observer) observer.disconnect();
        }

        announce(addedCount ? addedCount + ' more stories loaded.' : 'No more stories to load.');
      })
      .catch(function () {
        announce('Could not load more stories. Please try again.');
      })
      .finally(function () {
        loading = false;
        setLoadingState(link, false);
      });
  }

  function init() {
    var container = document.getElementById('yn-journal-pagination');
    if (!container) return;

    bindClick(document.getElementById('yn-journal-load-more'));
    observePagination(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
